import { createContext, useContext, useMemo, type ReactNode } from 'react';
import type { DatasetConfig } from './types';
import type { DatasetAtoms } from './atoms';

interface DatasetContextValue {
  config: DatasetConfig;
  atoms: DatasetAtoms;
}

const DatasetContext = createContext<DatasetContextValue | null>(null);

export const DatasetProvider = ({
  config,
  atoms,
  children,
}: {
  config: DatasetConfig;
  atoms: DatasetAtoms;
  children: ReactNode;
}) => {
  const value = useMemo(() => ({ config, atoms }), [config, atoms]);
  return (
    <DatasetContext.Provider value={value}>{children}</DatasetContext.Provider>
  );
};

export const useDatasetConfig = (): DatasetConfig => {
  const ctx = useContext(DatasetContext);
  if (!ctx)
    throw new Error('useDatasetConfig must be used inside DatasetProvider');
  return ctx.config;
};

export const useDatasetAtoms = (): DatasetAtoms => {
  const ctx = useContext(DatasetContext);
  if (!ctx)
    throw new Error('useDatasetAtoms must be used inside DatasetProvider');
  return ctx.atoms;
};
